import { useSelector } from 'react-redux';

import { selectCurrentUser, selectPrevUser } from '../selectors';

export default function useCurrentOrPrevUser() {
  const currentUser = useSelector(selectCurrentUser);
  const prevUser = useSelector(selectPrevUser);

  return currentUser || prevUser;
}
